import Project from '../project/project.model';
import User from '../user/user.model';

export default class ProjectPermission {
    public id = '';
    public project: Project = new Project();
    public user: User = new User();
    public manageUsers: number = 0;
    public get: number = 0;
    public update: number = 0;
    public delete: number = 0;
    public workOn: number = 0;
    public updateSchema: number = 0;
    public updateLayers: number = 0;
    public updateArcgis: number = 0;
    public updateTickets: number = 0;
    public createdAt: Date = new Date(0);

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = String(model.id);
        }
        if (model._id) {
            this.id = String(model._id);
        }
        if (model.project) {
            this.project = new Project(model.project);
        }
        if (model.user) {
            this.user = new User(model.user);
        }
        if (model.manageUsers) {
            this.manageUsers = model.manageUsers;
        }
        if (model.get) {
            this.get = model.get;
        }
        if (model.update) {
            this.update = model.update;
        }
        if (model.delete) {
            this.delete = model.delete;
        }
        if (model.workOn) {
            this.workOn = model.workOn;
        }
        if (model.updateSchema) {
            this.updateSchema = model.updateSchema;
        }
        if (model.updateLayers) {
            this.updateLayers = model.updateLayers;
        }
        if (model.updateArcgis) {
            this.updateArcgis = model.updateArcgis;
        }
        if (model.updateTickets) {
            this.updateTickets = model.updateTickets;
        }
        if (model.createdAt) {
            this.createdAt = model.createdAt;
        }
    }
}
